<template>
  <v-menu
    v-model="contextMenuModel"
    v-bind:target="[positionX, positionY]"
    absolute
  >

    <v-list style="overflow-y:auto;" data-cy="nodeSideMenu-contextMenu">
      <v-list-item @click="setSort('nameAsc')" data-cy="nodeSideMenu-contextMenu-sortByNameAsc">
        <v-list-item-title>
          {{ $t('routes.node.sortByNameAsc') }}
          <v-icon v-if="sortString==='nameAsc'" size="small" start>mdi-check</v-icon>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="setSort('nameDesc')" data-cy="nodeSideMenu-contextMenu-sortByNameDesc">
        <v-list-item-title>
          {{ $t('routes.node.sortByNameDesc') }}
          <v-icon v-if="sortString==='nameDesc'" size="small" start>mdi-check</v-icon>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="setSort('dateDesc')" data-cy="nodeSideMenu-contextMenu-sortByDateDesc">
        <v-list-item-title>
          {{ $t('routes.node.sortByDateDesc') }}
          <v-icon v-if="sortString==='dateDesc'" size="small" start>mdi-check</v-icon>
        </v-list-item-title>
      </v-list-item>

      <v-list-item @click="setSort('dateAsc')" data-cy="nodeSideMenu-contextMenu-sortByDateAsc">
        <v-list-item-title>
          {{ $t('routes.node.sortByDateAsc') }}
          <v-icon v-if="sortString==='dateAsc'" size="small" start>mdi-check</v-icon>
        </v-list-item-title>
      </v-list-item>

    </v-list>

  </v-menu>
</template>

<script>
export default {
  emits: ["setSort", 'update:modelValue'],
  name: "ExpansionpanelContextMenu",

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    positionX: {
      type: Number,
      required: true,
    },
    positionY: {
      type: Number,
      required: true,
    },
    sortString: {
      type: String,
      required: true,
    }
    // node: {
    //   type: Object,
    //   // required: true,
    // },
  },

  data() {
    return {};
  },

  methods: {
    setSort(sortString) {
      // console.log("Click on context menu!");
      this.$emit('setSort', sortString);
      this.$emit('update:modelValue', false);
    },
  },

  computed: {
    contextMenuModel: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      }
    },
  }
};
</script>

<style>
</style>
